const STEPS = {
  DATE: 'DATE',
  LOCATION: 'LOCATION',
  RESULTS: 'RESULTS',
}

const STEPS_LABELS = {
  DATE: 'Date',
  LOCATION: 'Location',
  RESULTS: 'Results',
}

const TIME_SLOTS = {
  MORNING: 'MORNING',
  LUNCH: 'LUNCH',
  AFTERNOON: 'AFTERNOON',
}

const DEFAULT_BA_PER_MISSION = 1
const DEFAULT_BA_PAY_ADJUSTMENT = 0

export {
  STEPS,
  STEPS_LABELS,
  TIME_SLOTS,
  DEFAULT_BA_PER_MISSION,
  DEFAULT_BA_PAY_ADJUSTMENT,
}
